/*
  Now playing at the café. Reads the café player's public JSON (the worker in now-playing-worker/), which looks
  like { playing, now: { title, artist, art, url }, context: { url }, queue: [{ title }] }, every 15 seconds
  while the tab is visible, and fills the record and its card. The record only appears once the feed has
  answered; if it cannot be reached the card says so rather than showing a stale track.
*/
document.querySelectorAll('[data-now-playing]').forEach((root) => {
  const url = root.dataset.nowPlaying;
  if (!url) return;
  const button = root.querySelector('summary');
  const card = root.querySelector('.np-card');
  const part = (name) => root.querySelector(`[data-np-${name}]`);
  const art = part('art');
  let seen = false;
  const show = (state) => {
    const off = !state.playing;
    button.dataset.playing = String(!off);
    button.setAttribute('aria-label', off ? root.dataset.labelOff : root.dataset.labelOn);
    card.toggleAttribute('data-off', off);
    part('title').textContent = off ? root.dataset.offlineTitle : state.title;
    part('artist').textContent = off ? root.dataset.offlineArtist : state.artist;
    part('link').href = (off ? root.dataset.offlineUrl : state.url) || '#';
    if (!off && state.art) {
      art.src = state.art;
      art.hidden = false;
    } else art.hidden = true;
    const note = part('note');
    note.textContent = '';
    if (off) note.textContent = state.reason || root.dataset.offlineCopy;
    else if (state.queue.length) {
      const label = document.createElement('b');
      label.textContent = note.dataset.next;
      note.append(label);
      state.queue.forEach((title, index) => {
        if (index) note.append(Object.assign(document.createElement('i'), { textContent: '·' }));
        note.append(title);
      });
    }
    if (!seen) {
      seen = true;
      root.hidden = false;
    }
  };
  const poll = async () => {
    if (document.hidden) return;
    try {
      const response = await fetch(url, { cache: 'no-store' });
      /* The record already holds its place in the bar: when the feed can't be read it says so rather than vanishing. */
      if (!response.ok) return show({ playing: false, reason: root.dataset.unreachableCopy });
      const data = await response.json();
      if (data.error) return show({ playing: false, reason: root.dataset.unreachableCopy });
      show({
        playing: Boolean(data.playing && data.now),
        title: data.now?.title,
        artist: data.now?.artist,
        art: data.now?.art,
        url: data.context?.url || data.now?.url,
        queue: (data.queue || []).slice(0, 3).map((track) => track.title),
      });
    } catch {
      show({ playing: false, reason: root.dataset.unreachableCopy });
    }
  };
  part('note').dataset.next = root.dataset.next || 'Up next';
  poll();
  setInterval(poll, 15000);
  document.addEventListener('visibilitychange', poll);
  /* Centred under the record, kept 12px inside the view, and growing out of the record, as the prototype placed its cards. */
  const nav = root.closest('c4-navigation');
  const place = () => {
    if (!root.open) return;
    const bar = root.closest('.nav-bar').getBoundingClientRect();
    const at = button.getBoundingClientRect();
    const width = card.offsetWidth;
    const centre = at.left + at.width / 2;
    const left = Math.max(12, Math.min(centre - width / 2, innerWidth - 12 - width));
    card.style.right = 'auto';
    card.style.left = `${left - bar.left}px`;
    card.style.transformOrigin = `${centre - left}px -10px`;
  };
  addEventListener('resize', place, { passive: true });
  /* One thing open at a time: opening the card closes any menu panel, and a menu panel opening closes the card. */
  root.addEventListener('toggle', () => {
    if (!root.open) return;
    place();
    nav?.querySelectorAll('.nav-disclosure[open]').forEach((other) => {
      other.open = false;
    });
  });
  nav?.addEventListener(
    'toggle',
    (event) => {
      if (event.target !== root && event.target.open && event.target.matches('.nav-disclosure'))
        root.open = false;
    },
    true,
  );
  /* With a mouse the card opens on hover, as the navigation's panels do, and closes shortly after the pointer leaves (long enough to cross the gap to the card). Touch and keyboard keep the ordinary press to open. */
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  let leaving;
  root.addEventListener('pointerenter', (event) => {
    if (!hover.matches || event.pointerType !== 'mouse') return;
    clearTimeout(leaving);
    root.open = true;
  });
  root.addEventListener('pointerleave', (event) => {
    if (!hover.matches || event.pointerType !== 'mouse') return;
    leaving = setTimeout(() => {
      root.open = false;
    }, 200);
  });
  button.addEventListener('click', (event) => {
    /* A mouse click on a card that hover has already opened leaves it open rather than toggling it shut. */
    if (hover.matches && root.open && event.detail > 0) event.preventDefault();
  });
  /* Close on Escape (before the navigation's own handler sees it) and on a click anywhere else. */
  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !root.open) return;
    event.stopPropagation();
    root.open = false;
    button.focus();
  });
  document.addEventListener('click', (event) => {
    if (root.open && !root.contains(event.target)) root.open = false;
  });
});
